import axios from "axios";
import React, { useState } from "react";
import Swal from "sweetalert2";

const Feedback = ({showModal,setShowModal}) => {
  const [comment, setComment] = useState("");
  const [subject, setSubject] = useState("");
  const [showReplyModel,setShowReplyModel] = useState(false);

  const handleShowModal = () => setShowModal(true); // Show modal
  const handleCloseModal = () => setShowModal(false); // Hide modal


  const handleSubmit = async (e) => {
    e.preventDefault();

    const feedbackData = {
      Id: 0, // Assuming this is auto-generated by the server
      Username: localStorage.getItem("username"),
      Comment: comment,
      UpdatedOn: new Date().toISOString(),
      Answered: false, // Assuming this is false by default
      AnsweredOn: null, // Assuming no answer yet
      CommentStatus: true, // Assuming the comment is active by default
      Subject: subject,
    };

    try {
      const response = await axios.post(
        "https://s3napi.s3nsoftware.com/api/UserMaster/UserFeedback",
        feedbackData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setComment("");
        setSubject("");
        handleCloseModal(); // Close the modal on success
        Swal.fire({
          title: "Feedback",
          text: `${response.data}`,
          icon: "success",
          timer: 3000,
        });
      } else {
        Swal.fire({
          title: "Feedbacl",
          text: "Submission Failed",
          icon: "info",
          timer: 3000,
        });
      }
    } catch (error) {
      //console.error("Error submitting feedback:", error);
      Swal.fire({
        title: "Feedback",
        text: "Submission Failed",
        icon: "info",
        timer: 3000,
      });
    }
  };

  return (
    <div>
      {/* Trigger Button */}
      <button className="btn btn-primary" style={{display:'none'}} onClick={handleShowModal}>
        Give Feedback
      </button>

      {/* Modal */}
      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="feedbackModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="feedbackModalLabel">
                  Feedback
                </h5>
                {/* <button
                  type="button"
                  className="close btn"
                  onClick={handleCloseModal}
                  style={{ position: "absolute", right: "15px", top: "15px" }}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button> */}
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="subject" className="form-label">
                      Subject
                    </label>

                    <textarea
                      maxLength={150}
                      className="form-control"
                      id="subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="comment" className="form-label">
                      Comment
                    </label>
                    <textarea
                      className="form-control"
                      id="comment"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      required
                    />
                  </div>
                  
                  
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCloseModal}
                    >
                      Close
                    </button>
                    

                    <button type="submit" className="btn btn-primary">
                      Submit Feedback
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backdrop */}
      {showModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default Feedback;
